<template>
  <layout>
    <div slot="content">
      <i-card title="添加航班" contentWidth="80%">
        <div slot="content">
          <el-form :model="fields" label-width="100px" :rules="validateRules" size="small">
            <el-form-item label="航班名称" prop="sailings_title">
              <el-input v-model="fields.sailings_title"></el-input>
            </el-form-item>
            <el-form-item label="航班号" prop="sailings_code">
              <el-input v-model="fields.sailings_code"></el-input>
            </el-form-item>
            <el-form-item label="默认库存" prop="sailings_code">
              <el-input v-model="fields.default_stock"></el-input>
            </el-form-item>
            <el-form-item label="登船口" prop="enter_no">
              <el-input v-model="fields.enter_no"></el-input>
            </el-form-item>
            <el-form-item label="时间信息">
              <el-row>
                <el-col :span="12" style="margin-right: 20px;">
                  <el-time-select
                    style="width: 100%"
                    placeholder="开船时间"
                    value-format="HH:mm"
                    v-model="fields.start_time"
                    :picker-options="timeSelectOption">
                  </el-time-select>
                </el-col>
                <el-col :span="11">
                  <el-time-select
                    style="width: 100%"
                    placeholder="到达时间"
                    value-format="HH:mm"
                    v-model="fields.end_time"
                    :picker-options="timeSelectOption">
                  </el-time-select>
                </el-col>
              </el-row>
            </el-form-item>
            <el-form-item label="码头信息">
              <el-row>
                <el-col :span="12" style="margin-right: 20px;">
                  <el-input v-model="fields.start_wharf" placeholder="开船码头"></el-input>
                </el-col>
                <el-col :span="11">
                  <el-input v-model="fields.end_wharf" placeholder="到达码头"></el-input>
                </el-col>
              </el-row>
            </el-form-item>
            <el-form-item label="集合信息">
              <el-row>
                <el-col :span="12" style="margin-right: 20px;">
                  <el-input v-model="fields.meeting_point" placeholder="集合点"></el-input>
                </el-col>
                <el-col :span="11">
                  <el-time-select
                    style="width: 100%"
                    placeholder="集合时间"
                    value-format="HH:mm"
                    v-model="fields.meeting_time"
                    :picker-options="timeSelectOption">
                  </el-time-select>
                </el-col>
              </el-row>
            </el-form-item>
            <el-form-item label="是否在售" prop="sale_status">
              <el-switch v-model="fields.sale_status"></el-switch>
            </el-form-item>
            <el-form-item label="是否区间" prop="is_range_status">
              <el-switch v-model="fields.is_range_status"></el-switch>
            </el-form-item>
            <el-form-item label="是否夜航" prop="is_night_status">
              <el-switch v-model="fields.is_night_status"></el-switch>
            </el-form-item>
            <el-form-item label="是否展示销量" prop="show_sale_count_status">
              <el-switch v-model="fields.show_sale_count_status"></el-switch>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" :loading="loading" @click="addSailings">立即提交</el-button>
              <router-link :to="{name:'settings.sailings'}">
                <el-button>返回列表</el-button>
              </router-link>
            </el-form-item>
          </el-form>
        </div>
      </i-card>
    </div>
  </layout>
</template>

<script>
export default {
  name: "sailings",
  data: function () {
    return {
      loading: false,
      fields: {
        sailings_title: '',
        sailings_code: '',
        start_time: '',
        end_time: '',
        start_wharf: '',
        end_wharf: '',
        meeting_point: '',
        meeting_time: '',
        sale_status: true,
        is_range_status: false,
        is_night_status: false,
        show_sale_count_status: true,
        default_stock: '',
        enter_no: '',
      },
      validateRules: {
        sailings_title: [
          {required: true, message: '航班名称不可为空'}
        ],
        sailings_code: [
          {required: true, message: '航班编号不可为空'}
        ],
        sale_status: [
          {required: true, message: '请选择销售状态'}
        ],
        is_range: [
          {required: true, message: '请选择是否为区间航班'}
        ],
        default_stock: [
          {required: true, message: '请输入默认库存'}
        ]
      },
      timeSelectOption: {
        start: '05:30',
        step: '00:05',
        end: '23:30'
      }
    }
  },
  methods: {
    addSailings: function () {
      this.loading = true;
      this.fields.on_sale = this.fields.sale_status ? 1 : -1;
      this.fields.is_range = this.fields.is_range_status ? 1 : -1;
      this.fields.is_night = this.fields.is_night_status ? 1 : -1;
      this.fields.show_sale_count = this.fields.show_sale_count_status ? 1 : -1;
      this.$http.request('addSailings', this.fields).then((res) => {
        this.loading = false;
        if (res.status === 'success') {
          let _self = this;
          this.$message({
            message: res.message,
            type: 'success',
            onClose: function () {
              _self.loading = false;
              _self.$router.push({name: 'settings.sailings'});
            }
          });
        }
      });
    },
    getSailings: function () {
      let sailingsId = this.$route.query.sailings_id;
      if (sailingsId) {
        this.$http.request('getSailingsInfo', {sailings_id: sailingsId}).then((res) => {
          if (res.status === 'success') {
            if (!res.data) {
              this.$message({
                message: '航班不存在',
                type: 'danger'
              });
            } else {
              this.fields = res.data;
            }
          }
        });
      }
    }
  },
  created: function () {
    this.getSailings();
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/settings/add_sailings.vue